module.exports = __webpack_public_path__ + "static/personal2-308fc7e872a14012097309702e98028b.jpg";